import axios from 'axios';
import * as commonActions from 'common.actions';
import getApiUrl from 'helpers/api-urls';

export const getMemberAccountDetails = (memberAccountNo, dispatch, callback) => {
    const url = `${getApiUrl('ballotAdmin', 'getMemberPersonalDetails')}/${memberAccountNo}`;
    dispatch(commonActions.setLoader(true));
    axios.get(url)
        .then(response => {
            dispatch(commonActions.setLoader(false));
            if (response.data.status) {
                callback(response.data.content);
            } else {
                dispatch(commonActions.setMessage(true, response.data.message));
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false));
            dispatch(commonActions.setMessage(true, '9151'));
        })
}

export const getBallotListAdmin = (filterBy, sortBy, sortOrder, offset, limit, callback, dispatch) => {
    const url = `${getApiUrl('ballotAdmin', 'getBallotListAdmin')}/${filterBy}/${sortBy}/${sortOrder}/${offset}/${limit}`;
    dispatch(commonActions.setLoader(true));
    axios.get(url)
        .then(response => {
            dispatch(commonActions.setLoader(false));
            if (response.data.status) {
                callback(response.data.content);
            } else {
                dispatch(commonActions.setMessage(true, response.data.message));
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false));
            dispatch(commonActions.setMessage(true, '9156'));
        })
}

export const getBallotItemsByLetterBallot = (filterBy, sortBy, sortOrder, offset, limit, callback, dispatch) => {
    const url = `${getApiUrl('ballotAdmin', 'getBallotItemByLetterBallot')}/${filterBy}?sortBy=${sortBy}&sortOrder=${sortOrder}&offset=${offset}&limit=${limit}`;
    dispatch(commonActions.setLoader(true));
    axios.get(url)
        .then(response => {
            dispatch(commonActions.setLoader(false));
            if (response.data.status) {
                callback(response.data.content);
            } else {
                dispatch(commonActions.setMessage(true, response.data.message));
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false));
            dispatch(commonActions.setMessage(true, '9156'));
        })
}
export const updateDescription = (dispatch, req, callback) => {
    const url = getApiUrl('ballotAdmin', 'updateDescription');
    dispatch(commonActions.setLoader(true));
    axios.put(url, req)
        .then((response) => {
            dispatch(commonActions.setLoader(false));
            if (response.data.status) {
                dispatch(commonActions.setMessage(true, '5019'));
                callback();
            } else {
                // Handle error case
                dispatch(commonActions.setMessage(true, '7505'));
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false));
            dispatch(commonActions.setMessage(true, '7505'));
        });
};

export const getBallotDetailsByLetterBallot = (filterBy, callback, dispatch) => {
    const url = `${getApiUrl('ballotAdmin', 'getBallotDetailsByLetterBallot')}/${filterBy}`;
    dispatch(commonActions.setLoader(true));
    axios.get(url)
        .then(response => {
            dispatch(commonActions.setLoader(false));
            if (response.data.status) {
                callback(response.data.content);
            } else {
                dispatch(commonActions.setMessage(true, response.data.message));
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false));
            dispatch(commonActions.setMessage(true, '8059'));
        })
};

export const getBallotVoteHistory = (memberAccountno, memberId, voteStatus, createdDateAfter, createdDateBefore, sortBy, sortOrder, offset, limit, isMemDetail, callback, dispatch) => {
    const url = `${getApiUrl('ballotAdmin', 'getBallotVoteHistory')}/${memberAccountno}/${memberId}/${voteStatus}/${createdDateAfter}/${createdDateBefore}/${sortBy}/${sortOrder}/${offset}/${limit}/${isMemDetail}`;
    dispatch(commonActions.setLoader(true));
    axios.get(url)
        .then(response => {
            dispatch(commonActions.setLoader(false));
            if (response.data.status) {
                callback(response.data.content);
            } else {
                dispatch(commonActions.setMessage(true, response.data.message));
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false));
            dispatch(commonActions.setMessage(true, '9158'));
        })
}

export const getVoteDetailsList = (reqData, callback, dispatch) => {
    const url = `${getApiUrl('ballotAdmin', 'getBallotVoteHistory')}/${reqData.letterBallot}/${reqData.memberId}/${reqData.sortBy}/${reqData.sortOrder}/${reqData.offset}/${reqData.limit}/${reqData.memberAccountNumber}`;
    dispatch(commonActions.setLoader(true));
    axios.get(url)
        .then(response => {
            dispatch(commonActions.setLoader(false));
            if (response.data.status) {
                callback(response.data.content);
            } else {
                dispatch(commonActions.setMessage(true, response.data.message));
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false));
            dispatch(commonActions.setMessage(true, '9158'));
        })
}